import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * Attaches the headers the backend requires on every request this app makes to its own
 * API, if configured (see environment.ts). Scoped to apiBaseUrl specifically — never to a
 * request going anywhere else — so neither value can leak to some other service a future
 * change adds an HttpClient call to.
 *
 * - X-Client-Id: always sent (environment.clientId has a committed default — this app's
 *   own identity on a backend that may serve more than one frontend). The backend rejects
 *   any request without it.
 * - X-Api-Key: sent only if one is configured; omitted entirely otherwise, matching the
 *   API's own fail-open behaviour when it has no keys configured either (typically local
 *   dev).
 */
export const backendHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiBaseUrl)) {
    return next(req);
  }

  const headers: Record<string, string> = { 'X-Client-Id': environment.clientId };
  if (environment.apiKey) {
    headers['X-Api-Key'] = environment.apiKey;
  }

  return next(req.clone({ setHeaders: headers }));
};
